import React from "react";
import ReactDOM from "react-dom";
import Main from "./main";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";

import "./index.css";
import "./freefrontend.css";
import "./media.css";

const rootElement = document.getElementById("root");

// optional configuration
const options = {
  // you can also just use 'bottom center'
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  offset: "30px",
  // you can also just use 'scale'
  transition: transitions.FADE,
};

ReactDOM.render(
  <AlertProvider template={AlertTemplate} {...options}>
    <Main />
  </AlertProvider>,
  rootElement
);
